<template>
    <div>

        <el-row class="column-name" justify="start">
            <span>详情</span>
        </el-row>

        <el-form label-position="right" ref="signRecordDetailInfo" :model="signRecordDetailInfo" label-width="120px">
            <el-row>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="姓名" prop="kpino">
                        <el-input v-model="signRecordDetailInfo.name" size="small" class="width70" disabled="true">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="证件号" prop="idno">
                        <el-input v-model="signRecordDetailInfo.idno" size="small" class="width70" disabled="true">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="数据中心" prop="deptid">
                        <dept-select size="mini" v-model="signRecordDetailInfo.deptid" class="width70" disabled="true">
                        </dept-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="上传时间" prop="enterDate">
                        <el-input v-model="signRecordDetailInfo.enterDate" size="small" class="width70" disabled="true">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="有效起始时间" prop="startData">
                        <el-input v-model="signRecordDetailInfo.startDate" size="small" class="width70" disabled="true">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="有效截止时间" prop="endData">
                        <el-input v-model="signRecordDetailInfo.endDate" size="small" class="width70" disabled="true">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-form-item label="附件" prop="endData">
                    <el-image style="width: 1100px; height:650px; pointer-events: none"
                              :src=signImgUrl></el-image>
                </el-form-item>
            </el-row>
        </el-form>

    </div>
</template>

<script>

import RegisterServer from "../../../api/register";
import DeptSelect from '@/components/dept'
import AttachmentServer from "../../../api/attachment";

export default {
    name: "signRecordDetail",

    components: {
        DeptSelect,
    },

    props: {
        signRecordInfo: {
            type: Object,
        },
    },

    data() {
        return {
            signRecordDetailInfo: {},

            signImgUrl: '',
        }
    },

    watch: {

        signRecordInfo: {
            deep: true,
            handler: function (newVal, oldVal) {
                RegisterServer.signRecord.get(newVal.id).then((res) => {
                    this.signRecordDetailInfo = res.data.data;

                    this.signImgUrl = '';
                    AttachmentServer.attachment.downloadList({
                        'ownerTable': 'REGSIGNRECORD',
                        'ownerId': newVal.id,
                    }).then(res => {
                        if (res != null && res.length > 0) {
                            this.signImgUrl = res[0].url;
                        }
                    }).catch(e => {
                        console.log(e);
                    });
                    this.$emit('afterQueryDetail');
                });
            }
        },

    },
}
</script>

<style scoped>

</style>